// Zoom fix for Shopify product gallery:
// - Prevent Flickity from swallowing zoom button interactions (desktop + mobile)
// - Open PhotoSwipe v4 manually using img[data-photoswipe-src]
// - Prevent double-open and FORCE cleanup after close (fixes "page unclickable")
(function () {
  function closest(el, sel) {
    return el && el.closest ? el.closest(sel) : null;
  }

  function getZoomBtn(e) {
    return closest(e.target, ".js-photoswipe__zoom");
  }

  function stopSliderCapture(e) {
    var btn = getZoomBtn(e);
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
  }

  // Stop Flickity starting a drag from the zoom button
  document.addEventListener("pointerdown", stopSliderCapture, true);
  document.addEventListener("mousedown", stopSliderCapture, true);
  document.addEventListener("touchstart", stopSliderCapture, { capture: true, passive: false });

  var isOpen = false;
  var suppressClickUntil = 0; // timestamp
  var activeGallery = null;

  function buildItems(galleryRoot) {
    var imgs = galleryRoot.querySelectorAll("img[data-photoswipe-src]");
    if (!imgs || !imgs.length) return { items: [], startIndex: 0 };

    var items = [];
    var startIndex = 0;

    var selectedImg = galleryRoot.querySelector(
      ".product-main-slide.is-selected img[data-photoswipe-src]"
    );

    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var src = img.getAttribute("data-photoswipe-src") || img.getAttribute("src");
      if (!src) continue;

      var w = parseInt(
        img.getAttribute("data-photoswipe-width") || img.getAttribute("width") || "1200",
        10
      );
      var h = parseInt(
        img.getAttribute("data-photoswipe-height") || img.getAttribute("height") || "1200",
        10
      );

      if (!isFinite(w) || w <= 0) w = 1200;
      if (!isFinite(h) || h <= 0) h = 1200;

      items.push({
        src: src,
        w: w,
        h: h,
        title: img.getAttribute("alt") || ""
      });

      if (selectedImg && img === selectedImg) startIndex = items.length - 1;
    }

    return { items: items, startIndex: startIndex };
  }

  function forcePsCleanup(pswpEl) {
    if (!pswpEl) pswpEl = document.querySelector(".pswp");
    if (!pswpEl) return;

    // Remove "open" state classes (PhotoSwipe uses several depending on timing)
    pswpEl.classList.remove(
      "pswp--open",
      "pswp--visible",
      "pswp--animate_opacity",
      "pswp--supports-fs",
      "pswp--touch",
      "pswp--css_animation"
    );

    // Ensure it can't block clicks even if it stays full-screen
    pswpEl.style.pointerEvents = "none";

    // Also ensure background layer can't intercept taps/clicks
    var bg = pswpEl.querySelector(".pswp__bg");
    if (bg) bg.style.pointerEvents = "none";

    // iOS / mobile: PhotoSwipe sometimes leaves scroll lock behind
    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    document.body.style.width = "";

    // If something created a transparent overlay, this helps unstick interactions
    // (no-op if not needed)
    try {
      document.body.offsetHeight; // force reflow
    } catch (e) {}
  }

  function openPhotoSwipe(btn) {
    if (isOpen) return;

    // If a previous instance exists, hard-close it
    if (activeGallery && typeof activeGallery.close === "function") {
      try { activeGallery.close(); } catch (e) {}
      activeGallery = null;
    }

    if (typeof PhotoSwipe !== "function" || typeof PhotoSwipeUI_Default !== "function") {
      console.warn("PhotoSwipe v4 not available on this page.");
      return;
    }

    var pswpEl = document.querySelector(".pswp");
    if (!pswpEl) {
      console.warn("Missing .pswp markup (PhotoSwipe container).");
      return;
    }

    // Reset click-blocking defaults before open (we re-enable on open)
    pswpEl.style.pointerEvents = "auto";
    var bg = pswpEl.querySelector(".pswp__bg");
    if (bg) bg.style.pointerEvents = "auto";

    var galleryRoot =
      closest(btn, "[data-product-images]") ||
      closest(btn, ".product__photos") ||
      document;

    var built = buildItems(galleryRoot);
    if (!built.items.length) {
      console.warn("No images found with data-photoswipe-src");
      return;
    }

    var options = {
      index: built.startIndex,
      bgOpacity: 0.9,
      history: false,
      focus: false,
      showHideOpacity: true,
      tapToClose: true,
      closeOnScroll: false
    };

    try {
      isOpen = true;

      var gallery = new PhotoSwipe(pswpEl, PhotoSwipeUI_Default, built.items, options);
      activeGallery = gallery;

      function onClosed() {
        isOpen = false;
        activeGallery = null;

        // Let animations finish, then cleanup hard
        setTimeout(function () {
          forcePsCleanup(pswpEl);
        }, 50);
      }

      gallery.listen("close", onClosed);
      gallery.listen("destroy", onClosed);

      gallery.init();
    } catch (err) {
      isOpen = false;
      activeGallery = null;
      console.error("PhotoSwipe failed to open:", err);
      forcePsCleanup(pswpEl);
    }
  }

  // Mobile-friendly open: pointerup, then suppress the following click to avoid double-open.
  document.addEventListener(
    "pointerup",
    function (e) {
      var btn = getZoomBtn(e);
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      suppressClickUntil = Date.now() + 700; // suppress click that follows pointerup
      openPhotoSwipe(btn);
    },
    true
  );

  // Desktop / fallback open: click
  document.addEventListener(
    "click",
    function (e) {
      var btn = getZoomBtn(e);
      if (!btn) return;

      if (Date.now() < suppressClickUntil) return;

      e.preventDefault();
      e.stopPropagation();

      openPhotoSwipe(btn);
    },
    true
  );

  // Extra safety: if user hits ESC / back / etc and something gets stuck, cleanup
  document.addEventListener("keyup", function (e) {
    if (e.key === "Escape") {
      var pswpEl = document.querySelector(".pswp");
      forcePsCleanup(pswpEl);
      isOpen = false;
      activeGallery = null;
    }
  });
})();
